import { createSlice } from "@reduxjs/toolkit";


export const InitialSearchState = {
    searchProductList: [],
    pageNo: 0,
};

const searchSlice = createSlice({
    name: "search",
    initialState: InitialSearchState,
    reducers: {

        setSearchProductList(state, { payload }) {
            state.searchProductList = payload;
        },
        addMoreSearchProductList(state, { payload }) {
            state.searchProductList = [...state.searchProductList, ...payload]
        },
        setPageNo(state, { payload }) {
            state.pageNo = payload;
        },



    }
});


export const searchActions = searchSlice.actions;
export default searchSlice;